<template>
    <div>
        <admin-page-header title="Criteria 정의 · 사전" :back="{ label: '질문지 목록', to: { name: 'TemplateList' } }" contained/>

        <b-container tag="section">
            <template v-if="!is_criteria_loaded">
                <b-row>
                    <b-col cols="12">
                        <div class="text-center">
                            <h5>Criteria Dictionary & Definition를 불러오는 중입니다.</h5>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <template v-else>
                <b-row class="mb-5 mb-lg-3">
                    <b-col cols="12" class="mb-2" order="1">
                        <h4 class="fw-600"> 집계값 조회 및 다운로드 Form </h4>
                    </b-col>
                    <b-col cols="12" lg="6" order="2">
                        <b-form @reset.prevent="resetAggregationFieldForm" @submit.prevent="downloadAggregationResult">
                            <b-form-row class="align-items-end">
                                <b-col cols="12" md="4">
                                    <b-form-group
                                        id="fieldset-aggregation-field-type"
                                        label="Criteria: 타입"
                                        label-for="input-aggregation-field-type"
                                        >
                                        <b-form-select id="input-aggregation-field-type"
                                            v-model="aggregationDownloadSearchForm.type"
                                            :options="measure_types"
                                            >
                                            <template #first><b-form-select-option :value="null">전체</b-form-select-option></template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <b-form-group
                                        id="fieldset-aggregation-field-category"
                                        label="Criteria: 카테고리"
                                        label-for="input-aggregation-field-category"
                                        >
                                        <b-form-select id="input-aggregation-field-category"
                                            v-model="aggregationDownloadSearchForm.category"
                                            :options="category_list"
                                            >
                                            <template #first><b-form-select-option :value="null">전체</b-form-select-option></template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <b-form-group
                                        id="fieldset-aggregation-field-definitionId"
                                        label="Criteria: Definition"
                                        label-for="input-aggregation-field-definitionId"
                                        >
                                        <b-form-select id="input-aggregation-field-definitionId"
                                            v-model="aggregationDownloadSearchForm.definitionId"
                                            :options="definitionOptions"
                                            >
                                            <template #first><b-form-select-option :value="null">전체</b-form-select-option></template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12" class="mb-md-3 text-right">
                                    <p v-if="aggregation_notice" class="small text-info text-left mb-2">{{ aggregation_notice }}</p>
                                    <b-btn variant="danger" type="reset" class="mr-2" :disabled="is_downloading_aggregationData">조건 초기화</b-btn>
                                    <b-btn variant="primary" type="submit" :disabled="is_downloading_aggregationData">
                                        집계값 조회 다운로드
                                        <b-spinner v-if="is_downloading_aggregationData" small />
                                    </b-btn>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-col>
                    <b-col cols="12" lg="6" order="3" class="mb-4 mb-lg-0">
                        <h5 class="text-warning strong">집계값 조회 Form 사용법</h5>
                        <ul>
                            <li>
                                <span class="text-underline">"Criteria: 타입" & "Criteria: Definition"</span>
                                은 각각 독립적으로 조회 및 집계값 다운로드 가능
                            </li>
                            <li>
                                <span class="text-underline">"Criteria: 카테고리"</span>는 <strong>"타입"</strong> 선택 필수</li>
                            <li>
                                <span class="text-underline">"Criteria: 타입 + 카테고리 + Definition"</span> <strong>혼합 조회</strong> 가능 (and 조건문)
                                <ul>
                                    <li>
                                        <strong class="font-italic">But,</strong> 선택된 Category와 Definition의 Category가 다를 경우, Definition의 category에
                                        맞게 수정해서 집계값 조회 및 다운로드
                                    </li>
                                    <li>
                                        선택된 Type과 선택된 Definition의 Type이 다를 경우에도, 위와 마찬가지로 맞게 수정해서 집계값 조회 및 다운로드
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </b-col>
                    
                </b-row>
                <b-row class="mb-5 mb-lg-3">
                    <b-col cols="12">
                        <hr>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="12" class="mb-2">
                        <h4 class="fw-600"> Criteria 수정 및 조회 </h4>
                    </b-col>
                </b-row>
                <b-row class="mb-5">
                    <b-col cols="12" xl="6" class="mb-5 mb-xl-0">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <h5 class="fw-500 mb-0">Criteria: 타입</h5>
                            <b-btn variant="secondary" size="sm" @click="collapseTabs.type = !collapseTabs.type" class="px-2">
                                생성 및 수정, 조회 Form {{ collapseTabs.type ? '접기' : '펼치기' }}
                            </b-btn>
                        </div>

                        <b-card no-body>
                            <!-- typeForm: { index: null, id: null, type_name: null, type_description: null } -->
                            <b-collapse id="collapse-type-tabs" v-model="collapseTabs.type">
                                <!-- 첫 탭에 active 를 두지 않는다: URL 로 연 '조회' 탭(tabIndex 1)을 b-tabs 가 첫 탭으로 덮어쓴다 -->
                                <b-tabs card v-model="tabIndexType">
                                    <b-tab title="생성 및 수정">
                                        <b-form @submit.prevent="createUpdateType" @reset="resetTypeForm" class="py-3">
                                            <b-form-row class="align-items-end">
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="type-group-name"
                                                        label="타입 이름 *"
                                                        label-for="type-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="type-name-input"
                                                            v-model="typeForm.type_name"
                                                            type="text"
                                                            placeholder="타입 이름을 입력해주세요"
                                                            required
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="type-group-description"
                                                        label="타입 설명"
                                                        label-for="type-description-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="type-description-input"
                                                            v-model="typeForm.type_description"
                                                            type="text"
                                                            placeholder="타입 설명을 입력해주세요"
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="auto" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2" :disabled="saving">저장</b-btn>
                                                    <b-btn type="reset" variant="danger">취소</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                    <b-tab title="조회">
                                        <!-- ('search') -->
                                        <b-form @submit.prevent="readTypes('search')" @reset="resetTypeSearchForm" class="py-3">
                                            <b-form-row class="align-items-end">
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="type-group-name"
                                                        label="타입 Id"
                                                        label-for="type-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="type-name-input"
                                                            v-model="typeSearchForm.id"
                                                            type="text"
                                                            placeholder="타입 Id을 입력해주세요"
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="type-group-name"
                                                        label="타입 이름"
                                                        label-for="type-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="type-name-input"
                                                            v-model="typeSearchForm.type_name"
                                                            type="text"
                                                            placeholder="타입 이름을 입력해주세요"
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="auto" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2">조회</b-btn>
                                                    <b-btn type="reset" variant="danger">초기화</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                </b-tabs>
                            </b-collapse>
                            
                            <b-table
                                :items="typelist"
                                :fields="typeField"
                                no-border-collapse
                                sticky-header
                                striped
                                hover
                                small
                                show-empty
                                empty-text="조회된 Type 데이터가 없습니다."
                                class="mb-0"
                                >

                                <template #empty="scope">
                                    <div v-if="load_errors.type" class="text-center my-3 text-danger">
                                        <h5>불러오지 못했습니다. ({{ load_errors.type }})</h5>
                                        <b-btn size="sm" variant="outline-danger" @click="readTypes()">다시 시도</b-btn>
                                    </div>
                                    <h5 v-else class="text-center my-3">{{ scope.emptyText }}</h5>
                                </template>

                                <template #cell(type_name)="row">
                                    {{ row.item.type_name }}

                                    <div class="small">({{ row.item.type_description }})</div>
                                </template>

                                <template #cell(type_parsing_and_download)="row">
                                    <div class="d-flex justify-content-center">
                                        <b-btn
                                            :id="`btn-criteria-parse-${row.item.type_name}-value`"
                                            class="text-center mr-3"
                                            variant="outline-dark"
                                            size="sm"
                                            v-b-tooltip.hover title="이 타입 전체 답변에서 값을 다시 추출"
                                            :disabled="is_running_parser_feature || row.item.is_parsing || row.item.is_aggregation_downloading"
                                            @click="parseCriteriaDefinition(row.item)"
                                            >
                                            <span v-show="!row.item.is_parsing">파싱</span>
                                            <b-spinner v-show="row.item.is_parsing" small label="Small Spinner" />
                                        </b-btn>

                                        <b-btn
                                            :id="`btn-criteria-aggregate-${row.item.type_name}-value`"
                                            class="text-center"
                                            variant="outline-dark"
                                            size="sm"
                                            :disabled="is_running_parser_feature || row.item.is_aggregation_downloading || row.item.is_parsing"
                                            @click="downloadAggregateCriteriaValueExcel(row.item)"
                                            >
                                            <span v-show="!row.item.is_aggregation_downloading">다운로드</span>
                                            <b-spinner v-show="row.item.is_aggregation_downloading" small label="Small Spinner" />
                                            
                                        </b-btn>
                                    </div>
                                </template>

                                <template #cell(control_group)="row">
                                    <b-btn variant="outline-dark" class="mr-2" size="sm" @click="editType(row.item.type_name)">
                                        <fa icon="edit"/>
                                    </b-btn>
                                    <b-btn variant="outline-danger" class="mr-2" size="sm" @click="deleteType(row.item.type_name)" :disabled="!!deleting_key">
                                        <fa icon="trash-alt" />
                                    </b-btn>
                                </template>
                            </b-table>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xl="6">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <h5 class="fw-500 mb-0">Criteria: 카테고리</h5>

                            <b-btn variant="secondary" size="sm" @click="collapseTabs.category = !collapseTabs.category" class="px-2">
                                생성 및 수정, 조회 Form {{ collapseTabs.category ? '접기' : '펼치기' }}
                            </b-btn>
                        </div>
                        <b-card no-body>
                            <!-- categoryForm: { index: null, id: null, category_name: null, category_description: null }, -->
                            <b-collapse id="collapse-category-tabs" v-model="collapseTabs.category">
                                <b-tabs card v-model="tabIndexCategory">
                                    <b-tab title="생성 및 수정">
                                        <b-form @submit.prevent="createUpdateCategory" @reset="resetCategoryForm" class="py-2">
                                            <b-form-row class="align-items-end">
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="category-group-name"
                                                        label="카테고리 이름 *"
                                                        label-for="category-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="category-name-input"
                                                            v-model="categoryForm.category_name"
                                                            type="text"
                                                            placeholder="카테고리 이름을 입력해주세요"
                                                            required
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="category-group-description"
                                                        label="카테고리 설명"
                                                        label-for="category-description-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="category-description-input"
                                                            v-model="categoryForm.category_description"
                                                            type="text"
                                                            placeholder="카테고리 설명을 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="auto" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2" :disabled="saving">저장</b-btn>
                                                    <b-btn type="reset" variant="danger">취소</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                    <b-tab title="조회">
                                        <b-form @submit.prevent="readCategory('search')" @reset="resetCategorySearchForm" class="py-2">
                                            <b-form-row class="align-items-end">
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="category-group-name"
                                                        label="카테고리 Id"
                                                        label-for="category-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="category-name-input"
                                                            v-model="categorySearchForm.category_id"
                                                            type="text"
                                                            placeholder="카테고리 Id를 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="category-group-description"
                                                        label="카테고리 이름"
                                                        label-for="category-description-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="category-description-input"
                                                            v-model="categorySearchForm.category_name"
                                                            type="text"
                                                            placeholder="카테고리 이름을 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="auto" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2">조회</b-btn>
                                                    <b-btn type="reset" variant="danger">초기화</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                </b-tabs>
                            </b-collapse>

                            <b-table
                                :items="categorylist"
                                :fields="categoryField"
                                no-border-collapse
                                sticky-header
                                striped
                                hover
                                small
                                show-empty
                                empty-text="조회된 Category 데이터가 없습니다."
                                class="mb-0"
                                >

                                <template #empty="scope">
                                    <div v-if="load_errors.category" class="text-center my-3 text-danger">
                                        <h5>불러오지 못했습니다. ({{ load_errors.category }})</h5>
                                        <b-btn size="sm" variant="outline-danger" @click="readCategory()">다시 시도</b-btn>
                                    </div>
                                    <h5 v-else class="text-center my-3">{{ scope.emptyText }}</h5>
                                </template>

                                <template #cell(control_group)="row">
                                    <b-btn variant="outline-dark" class="mr-2" size="sm" @click="editCategory(row.item.id)">
                                        <fa icon="edit"/>
                                    </b-btn>
                                    <b-btn variant="outline-danger" class="mr-2" size="sm" @click="deleteCategory(row.item.id)" :disabled="!!deleting_key">
                                        <fa icon="trash-alt" />
                                    </b-btn>
                                </template>
                            </b-table>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row class="criteria-main mb-5">
                    <b-col cols="12" xl="6" class="mb-5 mb-xl-0">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <h5 class="fw-500 mb-0">Criteria: Definition</h5>

                            <b-btn variant="secondary" size="sm" @click="collapseTabs.definition = !collapseTabs.definition" class="px-2">
                                생성 및 조회 Form {{ collapseTabs.definition ? '접기' : '펼치기' }}
                            </b-btn>
                        </div>

                        <b-card no-body>
                            <b-collapse id="collapse-definition-tabs" v-model="collapseTabs.definition">
                                <b-tabs card v-model="tabIndexDefinition">
                                    <b-tab title="생성">
                                        <div class="d-flex align-items-center justify-content-center h-100">
                                            <h5 class="text-secondary my-3 text-center">
                                                Criteria Definition의 경우, Subs의 정보가 필요하므로 질문지 편집 페이지의
                                                <br>
                                                Subs 편집창 - <i class="text-underline">Criteria Dictionary</i> 탭에서 생성해주시기 바랍니다.
                                            </h5>
                                        </div>
                                    </b-tab>
                                    <b-tab title="조회">
                                        <b-form @submit.prevent="readDefinitions('search')" @reset="resetDefinitionsSearchForm" class="py-3">
                                            <b-form-row class="mb-3">
                                                <!-- definitionSearchForm = { id: null, criteriaName: null, subsCode: null, theme: null, type: null } -->
                                                <b-col cols="12" sm="4">
                                                    <b-form-group
                                                        id="definition-group-id"
                                                        label="Definition ID"
                                                        label-for="definition-id-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="definition-id-input"
                                                            v-model="definitionSearchForm.id"
                                                            type="text"
                                                            placeholder="Definition ID를 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="4">
                                                    <b-form-group
                                                        id="definition-group-criteriaName"
                                                        label="Definition 이름"
                                                        label-for="definition-criteriaName-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="definition-criteriaName-input"
                                                            v-model="definitionSearchForm.criteriaName"
                                                            type="text"
                                                            placeholder="Definition 이름을 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="4">
                                                    <b-form-group
                                                        id="definition-group-subsCode"
                                                        label="Sub 코드"
                                                        label-for="definition-subsCode-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="definition-subsCode-input"
                                                            v-model="definitionSearchForm.subsCode"
                                                            type="text"
                                                            placeholder="subs 코드을 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row class="mb-3 align-items-end">
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="definition-group-theme"
                                                        label="유형"
                                                        label-for="definition-theme-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="definition-theme-select"
                                                            :options="theme_list"
                                                            v-model="definitionSearchForm.theme"
                                                            placeholder="유형을 선택해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm>
                                                    <b-form-group
                                                        id="definition-group-type"
                                                        label="Type"
                                                        label-for="definition-type-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="definition-type-select"
                                                            :options="measure_types"
                                                            v-model="definitionSearchForm.type"
                                                            placeholder="Type을 선택해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="auto" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2">조회</b-btn>
                                                    <b-btn type="reset" variant="danger">초기화</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                </b-tabs>
                            </b-collapse>

                            <b-table
                                :items="definitionlist"
                                :fields="definitionTableFields"
                                striped
                                hover
                                sticky-header
                                no-border-collapse
                                show-empty
                                empty-text="조회된 Definition 데이터가 없습니다."
                                class="mb-0"
                                >

                                <template #empty="scope">
                                    <div v-if="load_errors.definition" class="text-center my-3 text-danger">
                                        <h5>불러오지 못했습니다. ({{ load_errors.definition }})</h5>
                                        <b-btn size="sm" variant="outline-danger" @click="readDefinitions()">다시 시도</b-btn>
                                    </div>
                                    <h5 v-else class="text-center my-3">{{ scope.emptyText }}</h5>
                                </template>

                                <template #cell(criteria_name)="data">
                                    <div style="width: 100%;min-width: 160px;">
                                        {{ data.value }} ({{ data.item.criteria_id }})
                                    </div>
                                </template>

                                <template #cell(theme)="data">
                                    {{ theme_list_en[data.value] }}
                                </template>

                                <template #cell(sub_code)="data">
                                    <div style="width: 100%;max-width: 100px;word-break: break-all;">
                                        {{ data.value }}
                                    </div>
                                </template>

                                <template #cell(type)="data">
                                    {{ measure_types_pair[data.value] }}
                                </template>

                                <template #cell(control_group)="row">
                                    <b-btn variant="outline-dark" class="mr-2" size="sm"
                                        @click="showDefinitionDetails(row.item.id, row.detailsShowing, row.toggleDetails, 'edit')"
                                        >
                                        <fa icon="edit"/>
                                    </b-btn>
                                    <b-btn variant="outline-danger" class="mr-2" size="sm" @click="deleteDefinition(row.item.index, row.item.sub_code, row.item.id)" :disabled="!!deleting_key">
                                        <fa icon="trash-alt" />
                                    </b-btn>
                                    <b-btn variant="outline-info" size="sm"
                                        @click="showDefinitionDetails(row.item.id, row.detailsShowing, row.toggleDetails, 'detail')"
                                        >
                                        <fa icon="search" />
                                    </b-btn>
                                </template>

                                <template #row-details="row">
                                    <template v-if="row.item.is_edit_mode">
                                        <b-card class="mb-3">
                                            <b-form :ref="`definition-editForm-${row.item.id}`"
                                                @submit.prevent="onUpdateDefinition(row.item.id)"
                                                @reset="onResetDefinition(row.item.id)"
                                                >
                                                <b-form-row class="align-items-top mb-3">
                                                    <b-col cols="12" md="6">
                                                        <b-form-group
                                                            :id="`definition-group-${row.item.id}-criteria`"
                                                            label="측정 항목"
                                                            :label-for="`definition-group-${row.item.id}-criteria-input`"
                                                            class="mb-0"
                                                            >
                                                            <b-form-select
                                                                :id="`definition-group-${row.item.id}-criteria`"
                                                                v-model="row.item.changingInfo.criteria"
                                                                :options="dictionarylist"
                                                                placeholder="측정 항목을 선택해주세요"
                                                                text-field="criteria_name"
                                                                value-field="id"
                                                                :disabled="isUpdateCriteria"
                                                                required
                                                                />
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="6">
                                                        <b-form-group
                                                            :id="`definition-group-${row.item.id}-measure_type`"
                                                            label="측정 용도"
                                                            :label-for="`definition-group-${row.item.id}-measure_type-input`"
                                                            >
                                                            <b-form-select :id="`definition-group-${row.item.id}-measure_type-input`"
                                                                v-model="row.item.changingInfo.type"
                                                                :options="measure_types"
                                                                :disabled="isUpdateCriteria"
                                                                />
                                                        </b-form-group>
                                                    </b-col>
                                                </b-form-row>
                                                <b-form-row class="align-items-top mb-3">
                                                    <b-col cols="12" md="6">
                                                        <b-form-group
                                                            :id="`definition-group-${row.item.id}-year`"
                                                            label="연도"
                                                            :label-for="`definition-group-${row.item.id}-year-input`"
                                                            >
                                                            <b-input-group prepend="FY">
                                                                <b-form-input 
                                                                    :id="`definition-group-${row.item.id}-year-input`"
                                                                    type="number"
                                                                    v-model="row.item.changingInfo.year"
                                                                    :disabled="isUpdateCriteria"
                                                                    placeholder="직접 입력"
                                                                    :max="year_max"
                                                                    lazy
                                                                    number
                                                                    required
                                                                    />
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="6">
                                                        <b-form-group
                                                            :id="`definition-group-${row.item.id}-collection_year`"
                                                            label="데이터 수집 연도"
                                                            :label-for="`definition-group-${row.item.id}-collection_year-input`"
                                                            >
                                                            <b-input-group>
                                                                <b-form-input 
                                                                    :id="`definition-group-${row.item.id}-collection_year-input`"
                                                                    type="number"
                                                                    v-model="row.item.changingInfo.collection_year"
                                                                    :disabled="isUpdateCriteria"
                                                                    placeholder="직접 입력"
                                                                    :max="year_max"
                                                                    lazy
                                                                    number
                                                                    required
                                                                    />
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-form-row>
                                                <b-form-row class="align-items-top mb-3">
                                                    <b-col cols="12" class="text-right">
                                                        <b-btn type="submit" variant="primary"
                                                            class="mr-2"
                                                            :disabled="row.item.criteria_id === row.item.changingInfo.criteria
                                                                && row.item.type === row.item.changingInfo.type
                                                                && row.item.year === row.item.changingInfo.year
                                                                && row.item.collection_year === row.item.changingInfo.collection_year
                                                                "
                                                            >
                                                            저장
                                                        </b-btn>
                                                            <b-btn type="reset" variant="danger"
                                                                :disabled="row.item.criteria_id === row.item.changingInfo.criteria
                                                                    && row.item.type === row.item.changingInfo.type
                                                                    && row.item.year === row.item.changingInfo.year
                                                                    && row.item.collection_year === row.item.changingInfo.collection_year
                                                                    "
                                                            >
                                                            취소
                                                        </b-btn>
                                                    </b-col>
                                                </b-form-row>
                                            </b-form>
                                        </b-card>
                                    </template>
                                    <b-card>
                                        <h6 class="mb-3">Criteria Definition Subs Parser 데이터</h6>
                                        <b-table-simple class="w-100 mb-0" bordered small>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-th class="text-center">structure_idx</b-th>
                                                    <b-th class="text-center">key</b-th>
                                                    <b-th class="text-center">element_idx</b-th>
                                                    <b-th class="text-center">element_str_idx</b-th>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td class="text-center">{{ row.item.structure_idx }}</b-td>
                                                    <b-td class="text-center">{{ row.item.key }}</b-td>
                                                    <b-td class="text-center">{{ row.item.element_idx === null ? '-' : row.item.element_idx}}</b-td>
                                                    <b-td class="text-center">{{ row.item.element_str_idx === null ? '-' : row.item.element_str_idx}}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-th class="text-center">unit_structure_idx</b-th>
                                                    <b-th class="text-center">unit_element_idx</b-th>
                                                    <b-th class="text-center">unit_element_str_idx</b-th>
                                                    <b-th class="text-center">unit_key</b-th>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td class="text-center">{{ row.item.unit_structure_idx === null ? '-' : row.item.unit_structure_idx}}</b-td>
                                                    <b-td class="text-center">{{ row.item.unit_element_idx === null ? '-' : row.item.unit_element_idx}}</b-td>
                                                    <b-td class="text-center">{{ row.item.unit_element_str_idx === null ? '-' : row.item.unit_element_str_idx}}</b-td>
                                                    <b-td class="text-center">{{ row.item.unit_key }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-th class="text-center">unit_static_value</b-th>
                                                    <b-th class="text-center">year</b-th>
                                                    <b-th class="text-center">collection_year</b-th>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td class="text-center">{{ row.item.unit_static_value === null ? '-' : row.item.unit_static_value}}</b-td>
                                                    <b-td class="text-center">{{ row.item.year }}</b-td>
                                                    <b-td class="text-center">{{ row.item.collection_year }}</b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-card>
                                </template>
                            </b-table>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xl="6">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <h5 class="fw-500 mb-0">Criteria: Dictionary</h5>

                            <b-btn variant="secondary" size="sm" @click="collapseTabs.dictionary = !collapseTabs.dictionary" class="px-2">
                                생성 및 조회 Form {{ collapseTabs.dictionary ? '접기' : '펼치기' }}
                            </b-btn>
                        </div>
                        <b-card no-body>
                            <b-collapse id="collapse-dictionary-tabs" v-model="collapseTabs.dictionary">
                                <b-tabs card v-model="tabIndexDictionary">
                                    <b-tab title="생성">
                                        <b-form class="py-3" @submit.prevent="createDictionary" @reset.prevent="resetDictionaryForm">
                                            <b-form-row class="mb-3">
                                                <b-col cols="12" md="3">
                                                    <b-form-group
                                                        id="dictionary-group-name"
                                                        label="Criteria 이름 *"
                                                        label-for="dictionary-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="dictionary-name-input"
                                                            v-model="dictionaryForm.name"
                                                            type="text"
                                                            placeholder="Criteria 이름를 입력해주세요"
                                                            required
                                                            trim
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="3">
                                                    <b-form-group
                                                        id="dictionary-group-theme"
                                                        label="유형 *"
                                                        label-for="dictionary-theme-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="dictionary-theme-select"
                                                            :options="theme_list"
                                                            v-model="dictionaryForm.theme"
                                                            required
                                                            >
                                                            <template #first><b-form-select-option :value="null">선택</b-form-select-option></template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="3">
                                                    <b-form-group
                                                        id="dictionary-group-category"
                                                        label="카테고리 *"
                                                        label-for="definition-category-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="dictionary-category-select"
                                                            v-model="dictionaryForm.category"
                                                            :options="dictionaryCategoryOptions"
                                                            required
                                                            >
                                                            <template #first><b-form-select-option :value="null">선택</b-form-select-option></template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                <b-form-group
                                                    id="dictionary-group-inDictionary"
                                                    label="대시보드"
                                                    label-for="definition-inDictionary-checkbox"
                                                    class="mb-0"
                                                    >
                                                    <b-form-checkbox
                                                        id="dictionary-inDictionary-checkbox"
                                                        v-model="dictionaryForm.inDashboard"
                                                        >
                                                        적용
                                                    </b-form-checkbox>
                                                </b-form-group>
                                            </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col cols="12" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2" :disabled="saving">저장</b-btn>
                                                    <b-btn type="reset" variant="danger">초기화</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                    <b-tab title="조회">
                                        <b-form @submit.prevent="readDictionary('search')" @reset="resetDictionarySearchForm" class="py-3">
                                            <!-- dictionarySearchForm = { id: null, name: null, theme: null, category: null, inDashboard: null } -->
                                            <b-form-row class="mb-3">
                                                <b-col cols="12" md="3">
                                                    <b-form-group
                                                        id="dictionary-group-id"
                                                        label="Criteria ID"
                                                        label-for="dictionary-id-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="dictionary-id-input"
                                                            v-model="dictionarySearchForm.id"
                                                            type="text"
                                                            placeholder="Criteria ID를 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="3">
                                                    <b-form-group
                                                        id="dictionary-group-name"
                                                        label="Criteria 이름"
                                                        label-for="dictionary-name-input"
                                                        class="mb-0"
                                                        >
                                                        <b-form-input
                                                            id="dictionary-name-input"
                                                            v-model="dictionarySearchForm.name"
                                                            type="text"
                                                            placeholder="Criteria 이름를 입력해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="2">
                                                    <b-form-group
                                                        id="dictionary-group-theme"
                                                        label="유형"
                                                        label-for="dictionary-theme-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="dictionary-theme-select"
                                                            :options="theme_list"
                                                            v-model="dictionarySearchForm.theme"
                                                            placeholder="유형을 선택해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="2">
                                                    <b-form-group
                                                        id="dictionary-group-category"
                                                        label="카테고리"
                                                        label-for="definition-category-select"
                                                        class="mb-0"
                                                        >
                                                        <b-form-select
                                                            id="dictionary-category-select"
                                                            v-model="dictionarySearchForm.category"
                                                            :options="dictionaryCategoryOptions"
                                                            placeholder="Category를 선택해주세요"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group
                                                        id="dictionary-group-inDictionary"
                                                        label="대시보드"
                                                        label-for="dictionary-search-inDashboard-select"
                                                        class="mb-0"
                                                        >
                                                        <!-- 서버는 이 조건을 거르지 못해 받은 목록에서 거른다(값 없음은 미적용) -->
                                                        <b-form-select
                                                            id="dictionary-search-inDashboard-select"
                                                            v-model="dictionarySearchForm.inDashboard"
                                                            :options="dashboardFilterOptions"
                                                            />
                                                    </b-form-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col cols="12" class="text-right">
                                                    <b-btn type="submit" variant="primary" class="mr-2">조회</b-btn>
                                                    <b-btn type="reset" variant="danger">초기화</b-btn>
                                                </b-col>
                                            </b-form-row>
                                        </b-form>
                                    </b-tab>
                                </b-tabs>
                            </b-collapse>

                            <b-table
                                :items="dictionarylist"
                                :fields="dictionaryTableFields"
                                striped
                                hover
                                no-border-collapse
                                sticky-header
                                show-empty
                                empty-text="조회된 Dictionary 데이터가 없습니다."
                                class="mb-0"
                                >

                                <template #empty="scope">
                                    <div v-if="load_errors.dictionary" class="text-center my-3 text-danger">
                                        <h5>불러오지 못했습니다. ({{ load_errors.dictionary }})</h5>
                                        <b-btn size="sm" variant="outline-danger" @click="readDictionary()">다시 시도</b-btn>
                                    </div>
                                    <h5 v-else class="text-center my-3">{{ scope.emptyText }}</h5>
                                </template>

                                <template #cell(criteria_name)="data">
                                    <div style="width: 100%;min-width: 160px;">
                                        {{ data.value }}
                                    </div>
                                </template>

                                <template #cell(theme)="data">
                                    {{ theme_list_en[data.value] }}
                                </template>

                                <template #cell(category)="data">
                                    {{ category_list_en[data.value] }}
                                </template>

                                <template #cell(in_dashboard)="data">
                                    {{ data.value === '' ? '-' : data.value }}
                                </template>

                                <template #cell(control_group)="row">
                                    <b-btn variant="outline-dark" class="mr-2" size="sm"
                                        @click="showDictionaryDetails(row.item.id, row.detailsShowing, row.toggleDetails, 'edit')"
                                        >
                                        <fa icon="edit"/>
                                    </b-btn>
                                    <b-btn variant="outline-danger" class="mr-2" size="sm" @click="onDeleteDictionary(row.item.id)" :disabled="!!deleting_key">
                                        <fa icon="trash-alt" />
                                    </b-btn>
                                    <b-btn variant="outline-info" size="sm"
                                        @click="showDictionaryDetails(row.item.id, row.detailsShowing, row.toggleDetails, 'detail')"
                                        >
                                        <fa icon="search" />
                                    </b-btn>
                                </template>

                                <template #row-details="row">
                                    <template v-if="row.item.is_edit_mode">
                                        <b-card class="mb-3">
                                            <b-row>
                                                <b-col cols="12">
                                                    <b-form @submit.prevent="onUpdateDictionary(row.item.id)" @reset="onResetDictionary(row.item.id)">
                                                        <b-form-row class="mb-3">
                                                            <b-col cols md="4">
                                                                <b-form-group
                                                                    :id="`dictionary-group-${row.item.id}-criteria_name`"
                                                                    label="이름"
                                                                    :label-for="`dictionary-group-${row.item.id}-criteria_name-input`"
                                                                    class="mb-0"
                                                                    >
                                                                    <b-form-input 
                                                                        :id="`dictionary-group-${row.item.id}-criteria_name-input`"
                                                                        v-model="row.item.changingInfo.criteria_name"
                                                                        :disabled="isUpdateCriteria"
                                                                        placeholder="직접 입력"
                                                                        required
                                                                        />
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols md="4">
                                                                <b-form-group
                                                                    :id="`dictionary-group-${row.item.id}-category`"
                                                                    label="카테고리"
                                                                    :label-for="`dictionary-group-${row.item.id}-category-select`"
                                                                    class="mb-0"
                                                                    >
                                                                    <b-form-select :id="`dictionary-group-${row.item.id}-category-select`"
                                                                        v-model="row.item.changingInfo.category"
                                                                        :options="category_list"
                                                                        :disabled="isUpdateCriteria"
                                                                        />
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols md="4">
                                                                <b-form-group
                                                                    :id="`dictionary-group-${row.item.id}-theme`"
                                                                    label="데이터 유형"
                                                                    :label-for="`dictionary-group-${row.item.id}-theme-select`"
                                                                    class="mb-0"
                                                                    >
                                                                    <b-form-select :id="`dictionary-group-${row.item.id}-theme-select`"
                                                                        v-model="row.item.changingInfo.theme"
                                                                        :options="theme_list"
                                                                        :disabled="isUpdateCriteria"
                                                                        />
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-form-row>
                                                        <b-form-row>
                                                            <b-col cols md="8">
                                                                <b-form-group
                                                                    :id="`dictionary-group-${row.item.id}-description`"
                                                                    label="설명"
                                                                    :label-for="`dictionary-group-${row.item.id}-description-textarea`"
                                                                    class="mb-0"
                                                                    >
                                                                    <b-form-textarea
                                                                        :id="`dictionary-group-${row.item.id}-description-textarea`"
                                                                        v-model="row.item.changingInfo.description"
                                                                        placeholder="Criteria에 대한 설명"
                                                                        rows="2"
                                                                        max-rows="3"
                                                                        />
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols md="4">
                                                                <b-form-group
                                                                    :id="`dictionary-group-${row.item.id}-is_dashboard`"
                                                                    label="대시보드"
                                                                    :label-for="`dictionary-group-${row.item.id}-is_dashboard-checkbox`"
                                                                    class="mb-0"
                                                                    >
                                                                    <b-form-checkbox
                                                                        :id="`dictionary-group-${row.item.id}-is_dashboard-checkbox`"
                                                                        v-model="row.item.changingInfo.in_dashboard"
                                                                        >
                                                                        적용
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-form-row>
                                                        <b-form-row>
                                                            <b-col cols="12" class="text-right">
                                                                <b-btn type="submit" variant="primary"
                                                                    class="mr-2"
                                                                    :disabled="row.item.criteria_name === row.item.changingInfo.criteria_name
                                                                        && row.item.theme === row.item.changingInfo.theme
                                                                        && row.item.category === row.item.changingInfo.category
                                                                        && row.item.description === row.item.changingInfo.description
                                                                        && row.item.in_dashboard === row.item.changingInfo.in_dashboard
                                                                    "
                                                                    >
                                                                    저장
                                                                </b-btn>
                                                                    <b-btn type="reset" variant="danger"
                                                                        :disabled="row.item.criteria_name === row.item.changingInfo.criteria_name
                                                                            && row.item.theme === row.item.changingInfo.theme
                                                                            && row.item.category === row.item.changingInfo.category
                                                                            && row.item.description === row.item.changingInfo.type_description
                                                                            && row.item.in_dashboard === row.item.changingInfo.in_dashboard
                                                                        "
                                                                    >
                                                                    취소
                                                                </b-btn>
                                                            </b-col>
                                                        </b-form-row>
                                                    </b-form>
                                                </b-col>
                                            </b-row>
                                        </b-card>
                                    </template>
                                    
                                    <b-card>
                                        <b-table-simple class="w-100 mb-0" bordered small>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td class="text-center" style="width: 70px;">설명</b-td>
                                                    <b-td class="text-center bg-white"> {{ !row.item.description || row.item.description === '' ? '-' : row.item.description }} </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-card>
                                </template>
                            </b-table>
                        </b-card>
                        
                    </b-col>
                </b-row>
            </template>
        </b-container>
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import downloadFile from '@shared_mixins/downloadFile';
import unsavedChangesGuard from '@shared/mixin/unsaved-changes-guard';

// 검색 조건을 URL 에 둘 때 섹션별 키 → 검색 폼 필드 (Definition 은 목록 API 가 없어 제외)
const SEARCH_QUERY_KEYS = {
    type: { form: 'typeSearchForm', tab: 'tabIndexType', read: 'readTypes', keys: { type_id: 'id', type_name: 'type_name' } },
    category: { form: 'categorySearchForm', tab: 'tabIndexCategory', read: 'readCategory', keys: { cat_id: 'category_id', cat_name: 'category_name' } },
    dictionary: { form: 'dictionarySearchForm', tab: 'tabIndexDictionary', read: 'readDictionary', keys: { dict_id: 'id', dict_name: 'name', dict_theme: 'theme', dict_category: 'category', dict_dashboard: 'inDashboard' } }
}

export default {
    name: 'managing-criteria',
    mixins: [
        downloadFile,
        unsavedChangesGuard
    ],
    data () {
        return {
            load_errors: { type: '', category: '', definition: '', dictionary: '' },
            is_type_loaded: false,
            is_category_loaded: false,
            is_definition_loaded: false,
            is_dictionary_loaded: false,
            typelist: null,
            categorylist: null,
            dictionarylist: null,
            definitionlist: null,
            typeForm: {
                index: null,
                id: null,
                type_name: null,
                type_description: null
            },
            typeSearchForm: {
                id: null,
                type_name: null
            },
            categoryForm: {
                index: null,
                id: null,
                category_name: null,
                category_description: null
            },
            categorySearchForm: {
                category_id: null,
                category_name: null
            },
            definitionSearchForm: {
                id: null,
                criteriaName: null,
                subsCode: null,
                theme: null,
                type: null
            },
            dictionaryForm: {
                name: null,
                theme: null,
                category: null,
                inDashboard: null,
            },
            dictionarySearchForm: {
                id: null,
                name: null,
                theme: null,
                category: null,
                inDashboard: null
            },
            typeField: [
                {
                    key: 'index',
                    label: 'Index',
                    sortable: true,
                    thStyle: { width: '80px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    thStyle: { width: '80px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'type_name',
                    label: '타입',
                    sortable: true,
                    thStyle: { width: '170px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'type_parsing_and_download',
                    label: '데이터 파싱 및 다운로드',
                    sortable: true,
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'control_group',
                    label: '수정 및 삭제',
                    // label: '',
                    sortable: false,
                    thClass: ['text-center'],
                    thStyle: { maxWidth: '20%' },
                    tdClass: ['text-center']
                }
            ],
            categoryField: [
                {
                    key: 'index',
                    label: 'Index',
                    sortable: true,
                    thStyle: { width: '90px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'id',
                    label: 'Id',
                    sortable: true,
                    thStyle: { width: '90px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'category_name',
                    label: '카테고리 이름',
                    sortable: true,
                    thStyle: { width: '130px' },
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'category_description',
                    label: '설명',
                    sortable: true,
                    thClass: ['px-3'],
                    tdClass: ['px-3']
                },
                {
                    key: 'control_group',
                    label: '수정 및 삭제',
                    sortable: false,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                }
            ],
            definitionTableFields: [
                {
                    key: 'id',
                    label: 'Id',
                    sortable: false,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'criteria_name',
                    label: '측정 항목 (id)',
                    sortable: false,
                    thStyle: { width: '180px' },
                    thClass: ['text-center']
                },
                {
                    key: 'sub_code',
                    label: 'Sub code',
                    sortable: false,
                    thClass: ['text-center'],
                    thStyle: { maxWidth: '100px' }
                },
                {
                    key: 'theme',
                    label: '유형',
                    sortable: false,
                    thClass: ['text-center'],
                    thStyle: { maxWidth: '90px' },
                    tdClass: ['text-center'],
                },
                {
                    key: 'type',
                    label: '용도',
                    sortable: false,
                    thClass: ['text-center'],
                    thStyle: { maxWidth: '70px' },
                    tdClass: ['text-center'],
                },
                {
                    key: 'control_group',
                    label: '수정 및 삭제',
                    sortable: false,
                    thClass: ['text-nowrap', 'text-center'],
                    thStyle: { minWidth: '150px', maxWidth: '20%' },
                    tdClass: ['text-center']
                }
            ],
            dictionaryTableFields: [
                {
                    key: 'id',
                    label: 'Id',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'criteria_name',
                    label: 'Criteria 이름',
                    sortable: true,
                    thStyle: { width: '200px' },
                    thClass: ['text-center']
                },
                {
                    key: 'theme',
                    label: '데이터 유형',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'category',
                    label: '카테고리',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'in_dashboard',
                    label: '대시보드',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'control_group',
                    label: '수정 및 삭제',
                    sortable: false,
                    thClass: ['text-nowrap', 'text-center'],
                    thStyle: { minWidth: '150px' },
                    tdClass: ['text-center']
                }
            ],
            isUpdateCriteria: false,
            measure_types: [],
            measure_types_pair: {},
            category_list: [],
            category_list_en: {},
            theme_list: [
                { text: '숫자', value: 'num' },
                { text: '텍스트', value: 'str' },
                { text: '라디오 버튼', value: 'radio' },
            ],
            theme_list_en: {
                num: '숫자',
                str: '텍스트',
                radio: '라디오 버튼'
            },
            tabIndexType: 0,
            tabIndexCategory: 0,
            tabIndexDefinition: 0,
            tabIndexDictionary: 0,
            collapseTabs: {
                type: false,
                category: false,
                definition: false,
                dictionary: false
            },
            dashboardFilterOptions: [
                { text: '전체', value: null },
                { text: '적용', value: true },
                { text: '미적용 (값 없음 포함)', value: false }
            ],
            is_running_parser_feature: false,
            deleting_key: null,
            saving: false,
            is_downloading_aggregationData: false,
            aggregation_notice: '',
            aggregationDownloadSearchForm: {
                type: null,
                category: null,
                definitionId: null
            }
        }
    },
    computed: {
        is_criteria_loaded () {
            return this.is_definition_loaded && this.is_dictionary_loaded
        },
        year_max () {
            return new Date().getFullYear()
        },
        definitionOptions () {
            return (this.definitionlist || []).map(d => ({ value: d.id, text: `${d.criteria_name} (${d.sub_code})` }))
        },
        // Dictionary 카테고리 선택지는 Category 검색 결과(categorylist)가 아니라 전체 목록에서 만든다
        dictionaryCategoryOptions () {
            return this.category_list.map(({ value }) => ({ value, text: this.category_list_en[value] || value }))
        },
        // unsaved-changes-guard: 입력 중인 생성/수정 폼이나 바꾼 채 저장하지 않은 행 편집이 있으면 이탈 확인
        // (행은 상세 보기로 바꿔도 편집값이 남으므로 수정 모드와 무관하게 원본과 비교)
        hasUnsavedChanges () {
            const differs = (form, keys, original) => keys.some(k => (form[k] || null) !== ((original && original[k]) || null))
            const byId = (list, id) => (id == null ? null : (list || []).find(row => row.id === id))
            const same = (a, b) => (a ?? '') === (b ?? '')
            const { typeForm, categoryForm } = this
            return differs(typeForm, ['type_name', 'type_description'], byId(this.typelist, typeForm.id))
                || differs(categoryForm, ['category_name', 'category_description'], byId(this.categorylist, categoryForm.id))
                || differs(this.dictionaryForm, ['name', 'theme', 'category', 'inDashboard'], null)
                || (this.dictionarylist || []).some(d => d.changingInfo && (
                    ['criteria_name', 'theme', 'category', 'description'].some(k => !same(d[k], d.changingInfo[k]))
                    || !!d.in_dashboard !== !!d.changingInfo.in_dashboard))
                || (this.definitionlist || []).some(d => d.changingInfo && (
                    d.criteria_id !== d.changingInfo.criteria || d.type !== d.changingInfo.type
                    || d.year !== d.changingInfo.year || d.collection_year !== d.changingInfo.collection_year))
        }
    },
    watch: {
        async tabIndexType (_current, _prev) {
            // "조회" 탭에서 "생성 및 수정" 탭으로 이동할때 "조회" 탭에 있는 history 및 검색 데이터 초기화
            // "생성 및 수정" 탭 index = 0
            // "조회" 탭 index = 1
            const isInitial = Object.values(this.typeSearchForm).every(_value => _value === null)
            if (!isInitial && _prev !== 0 && _current === 0) {
                await this.resetTypeSearchForm()
            }
        },
        async tabIndexCategory (_current, _prev) {
            // "조회" 탭에서 "생성 및 수정" 탭으로 이동할때 "조회" 탭에 있는 history 및 검색 데이터 초기화
            // "생성 및 수정" 탭 index = 0
            // "조회" 탭 index = 1
            const isInitial = Object.values(this.categorySearchForm).every(_value => _value === null)
            if (!isInitial && _prev !== 0 && _current === 0) {
                await this.resetCategorySearchForm()
            }
        },
        async tabIndexDefinition (_current, _prev) {
            // "조회" 탭에서 "생성 및 수정" 탭으로 이동할때 "조회" 탭에 있는 history 및 검색 데이터 초기화
            // "생성 및 수정" 탭 index = 0
            // "조회" 탭 index = 1
            const isInitial = Object.values(this.definitionSearchForm).every(_value => _value === null)
            if (!isInitial && _prev !== 0 && _current === 0) {
                await this.resetDefinitionsSearchForm()
            }
        },
        async tabIndexDictionary (_current, _prev) {
            // "조회" 탭에서 "생성 및 수정" 탭으로 이동할때 "조회" 탭에 있는 history 및 검색 데이터 초기화
            // "생성 및 수정" 탭 index = 0
            // "조회" 탭 index = 1
            const isInitial = Object.values(this.dictionarySearchForm).every(_value => _value === null)
            if (!isInitial && _prev !== 0 && _current === 0) {
                await this.resetDictionarySearchForm()
            }
        },
        aggregationDownloadSearchForm: {
            deep: true,
            handler ({ type, category }) {
                this.replaceQuery({ agg_type: type, agg_category: category })
            }
        }
    },
    async created () {
        this.is_definition_loaded = false
        this.is_dictionary_loaded = false
        await Promise.all([
            this.readTypes(),
            this.readCategory(),
            this.readDictionary(),
            this.readDefinitions()
        ])
        await this.restoreFromQuery()
    },
    mounted () {},
    methods: {
        errorReason (error) {
            return error && error.response
                ? getErrorMessage(error, `서버 오류(${error.response.status})`)
                : '네트워크 오류'
        },
        setLoadError (key, error) {
            this.load_errors[key] = this.errorReason(error)
        },
        // parser 백엔드는 실패도 상태 200 + [사유, 상태코드] 배열로 보낸다
        // (df_backend_custom app/assessment/parser.py 의 jsonify(msg, status)). 진짜 4xx/5xx 와 같은 모양으로 catch 에 보낸다.
        throwIfFlattenedError (data) {
            if (Array.isArray(data) && data.length === 2 && Number.isInteger(data[1]) && data[1] >= 400) {
                throw Object.assign(new Error(`parser ${data[1]}`), { response: { status: data[1], data: data[0] } })
            }
        },
        // responseType blob 요청의 오류 본문(Blob)에서 사유를 읽는다
        async blobErrorMessage (error) {
            const response = error && error.response
            if (!response) return '네트워크 오류'
            let data = response.data
            if (data instanceof Blob) {
                const text = await data.text()
                try {
                    data = JSON.parse(text)
                } catch (e) {
                    data = text
                }
            }
            return getErrorMessage({ response: { data } }, `서버 오류(${response.status})`)
        },
        // 엑셀 응답이 200 이어도 실제로는 JSON(null = 결과 없음, [사유, 상태코드] = 실패)일 수 있다. 문제가 없으면 null.
        async excelResponseProblem (response, emptyMessage) {
            const blob = response.data
            if (!blob || !blob.size) return emptyMessage
            if (!/json/i.test(blob.type || '')) return null
            let body = null
            try {
                body = JSON.parse(await blob.text())
            } catch (e) {
                return null
            }
            if (body === null) return emptyMessage
            return getErrorMessage({ response: { data: Array.isArray(body) ? body[0] : body } }, emptyMessage)
        },
        replaceQuery (patch) {
            const query = { ...this.$route.query }
            Object.entries(patch).forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') delete query[key]
                else query[key] = String(value)
            })
            const current = this.$route.query
            const keys = Object.keys(query)
            if (keys.length === Object.keys(current).length && keys.every(k => current[k] === query[k])) return
            this.$router.replace({ query }).catch(() => {})
        },
        // 섹션 검색 폼 → URL 키 (대시보드 true/false 는 1/0)
        searchQueryPatch (section) {
            const { form, keys } = SEARCH_QUERY_KEYS[section]
            const patch = {}
            Object.entries(keys).forEach(([key, field]) => {
                const value = this[form][field]
                patch[key] = typeof value === 'boolean' ? (value ? 1 : 0) : value
            })
            return patch
        },
        // 첫 조회 뒤 URL 의 검색 조건을 폼에 넣고 그 섹션만 다시 조회한다. 선택지에 없는 값은 버리고 URL 도 보정한다.
        async restoreFromQuery () {
            const q = this.$route.query
            const text = v => (typeof v === 'string' && v.trim() ? v.trim() : null)
            const oneOf = (v, options) => (options.some(o => o.value === v) ? v : null)
            const values = {
                type_id: text(q.type_id),
                type_name: text(q.type_name),
                cat_id: text(q.cat_id),
                cat_name: text(q.cat_name),
                dict_id: text(q.dict_id),
                dict_name: text(q.dict_name),
                dict_theme: oneOf(text(q.dict_theme), this.theme_list),
                dict_category: oneOf(text(q.dict_category), this.category_list),
                dict_dashboard: q.dict_dashboard === '1' ? true : q.dict_dashboard === '0' ? false : null
            }

            const searches = []
            const patch = {}
            Object.entries(SEARCH_QUERY_KEYS).forEach(([section, { form, tab, read, keys }]) => {
                const restored = {}
                Object.entries(keys).forEach(([key, field]) => { restored[field] = values[key] })
                if (Object.values(restored).some(v => v !== null)) {
                    this[form] = restored
                    this[tab] = 1
                    this.collapseTabs[section] = true
                    searches.push(this[read]('search'))
                }
                Object.assign(patch, this.searchQueryPatch(section))
            })
            await Promise.all(searches)

            const agg_type = oneOf(text(q.agg_type), this.measure_types)
            const agg_category = oneOf(text(q.agg_category), this.category_list)
            this.aggregationDownloadSearchForm = { type: agg_type, category: agg_category, definitionId: null }
            this.replaceQuery({ ...patch, agg_type, agg_category })
        },
        setTypeOptions (types) {
            this.measure_types_pair = types.reduce((_typesPair, _type) => {
                _typesPair[_type.type_name.toLowerCase()] = _type.type_name
                return _typesPair
            }, {})
            this.measure_types = types.map(_type => ({ text: _type.type_name, value: _type.type_name.toLowerCase() }))
        },
        // Type 생성·수정·삭제 뒤 다른 섹션의 타입 선택지를 새 목록으로 (표는 건드리지 않는다)
        async refreshTypeOptions () {
            try {
                this.setTypeOptions((await this.$axios.get('/parser/types')).data)
            } catch (error) {
                console.log(` ~ error => `, error);
            }
        },
        async readTypes (mode = 'initial') {
            let readTypeURL = '/parser/types'
            if (mode === 'search') {
                const { id, type_name } = this.typeSearchForm
                if (!id && !type_name) {
                    this.$EventBus.$emit('toast-warning', 'Type 조회', '검색 조건을 하나 이상 입력해 주세요.')
                    return false
                }
                readTypeURL = { url: `/parser/types`, params: {} }
                if (id) readTypeURL.params.id = id
                if (type_name) readTypeURL.params.type_name = type_name
            }

            try {
                this.is_type_loaded = false
                this.load_errors.type = ''

                // 응답을 기다리는 동안 폼을 바꿔도 URL 에는 실제로 조회한 조건을 남긴다
                const searchPatch = mode === 'search' ? this.searchQueryPatch('type') : null
                const res_types = await this.$axios(readTypeURL)
                this.typelist = res_types.data.map(_type => ({ ..._type, is_parsing: null, is_aggregation_downloading: null }))

                if (mode === 'initial') {
                    this.setTypeOptions(res_types.data)
                }
                if (searchPatch) this.replaceQuery(searchPatch)

                this.is_type_loaded = true
            } catch (error) {
                if (error?.response?.status === 401) return
                this.setLoadError('type', error)
                this.common_error_handling(error)
            }
        },
        async createUpdateType () {
            if (this.saving) return
            const { id, type_name, type_description } = this.typeForm
            if (!type_name) {
                this.$EventBus.$emit('toast-warning', 'Type 저장', '타입 이름을 입력해 주세요.')
                return
            }
            const _newType = { type_name }
            if (type_description) {
                _newType.type_description = type_description
            }
            // id 가 있으면 수정, 없으면 신규
            if (id != null) _newType.id = id

            this.saving = true
            try {
                let res_type = await this.$axios.post('parser/types', _newType)
                this.throwIfFlattenedError(res_type.data)
                if (res_type.data.length) {
                    const _updated_type = res_type.data[0]
                    this.typelist = this.typelist || []
                    const _update_target_type_idx = this.typelist.findIndex(({ id }) => id === _updated_type.id)

                    if (_update_target_type_idx < 0) {
                        this.typelist.push({ index: this.typelist.length, ..._updated_type, is_parsing: null, is_aggregation_downloading: null })
                    } else {
                        this.typelist[_update_target_type_idx].type_name = _updated_type.type_name
                        this.typelist[_update_target_type_idx].type_description = _updated_type.type_description
                    }
                }
                this.$EventBus.$emit('toast-success', 'Type 저장', `'${type_name}' 을(를) 저장했습니다.`)
                // 폼에 수정한 id 가 남으면 다음 저장이 같은 Type 을 덮어쓴다
                this.resetTypeForm()
                this.refreshTypeOptions()
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.handlingErrorOnCreateUpdateType(error)
            } finally {
                this.saving = false
            }
        },
        async handlingErrorOnCreateUpdateType (error) {
            if (error.response && error.response.status === 409) {
                this.$EventBus.$emit('toast-failure', 'Type 저장 실패', '이미 등록된 Type 이름입니다.')
                return
            }
            this.$EventBus.$emit('toast-failure', 'Type 저장 실패', `${this.errorReason(error)} Type 목록을 다시 불러옵니다.`)
            await this.readTypes()
        },
        async editType (typeName) {
            this.resetTypeForm()
            const _edit_target_type = this.typelist.find(({ type_name }) => type_name === typeName)
            if (!_edit_target_type) {
                this.$EventBus.$emit('toast-failure', '알림', '잘못된 Type 입니다. 목록을 다시 불러옵니다.')
                await this.readTypes()
            } else {
                const { index, id, type_name, type_description } = _edit_target_type
                this.typeForm = { index, id, type_name, type_description }

                if (!this.collapseTabs.type) {
                    this.collapseTabs.type = true
                }
                // 조회 탭에서 눌러도 수정 폼이 보이게 '생성 및 수정' 탭으로
                this.tabIndexType = 0
            }
        },
        confirmDelete (title, name, id) {
            return this.$showModal({
                type: 'confirm',
                state: 'error',
                title,
                message: `'${name}' (ID ${id}) 을(를) 삭제합니다. 서버에서 바로 삭제되며 되돌릴 수 없습니다. 이 항목을 쓰는 파서 설정이 있으면 동작이 바뀔 수 있습니다.`
            })
        },
        async deleteType (typeName) {
            if (this.deleting_key) return
            const _edit_target_type = this.typelist.find(({ type_name }) => type_name === typeName)
            const _is_confirmed_Type = await this.confirmDelete('Type 삭제', typeName, _edit_target_type?.id ?? '-')
            if (!_is_confirmed_Type) return
            this.deleting_key = `type-${_edit_target_type?.id}`
            try {
                
                if (!_edit_target_type) {
                    this.$EventBus.$emit('toast-failure', '알림', '잘못된 Type id 입니다. 리스트를 다시 불러오겠습니다.')
                    await this.readTypes()
                } else {
                    const _deleteType = { id: _edit_target_type.id }
                    const res_delete = await this.$axios.delete('parser/types', { data: _deleteType })
                    this.throwIfFlattenedError(res_delete.data)
                    const _delete_target_type = this.typelist.findIndex(({ type_name }) => type_name === typeName)

                    if (_delete_target_type < 0) {
                        this.$EventBus.$emit('toast-failure', '알림', '잘못된 Type id 입니다. 리스트를 다시 불러오겠습니다.')
                        await this.readTypes()
                    } else {
                        this.typelist.splice(_delete_target_type, 1)
                        this.$EventBus.$emit('toast-success', 'Type 삭제', `'${typeName}' 을(를) 삭제했습니다.`)
                    }
                    this.refreshTypeOptions()
                }
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.common_error_handling(error, this.handlingErrorDeleteType)
            } finally {
                this.deleting_key = null
            }
        },
        async handlingErrorDeleteType (error) {
            if (error.response) {
                const { status } = error.response
                if (status === 404) {
                    this.$EventBus.$emit('toast-failure', '알림', '이미 삭제되었거나 존재하지 않는 Criteria Type 입니다. Type 데이터를 새로 불러오겠습니다.')
                } else {
                    this.$EventBus.$emit('toast-failure', '알림', '죄송합니다. 에러가 발생해 Type 데이터를 새로 불러오겠습니다.')
                }
                await this.readTypes()
            } else {
                this.$EventBus.$emit('toast-failure', '알림', '죄송합니다. 알 수 없는 에러가 발생해 Type 데이터를 새로 불러오겠습니다.')
                await this.readTypes()
            }
        },
        resetTypeForm () {
            this.typeForm = { index: null, id: null, type_name: null, type_description: null }
        },
        async resetTypeSearchForm () {
            this.typeSearchForm = { id: null, type_name: null }
            this.replaceQuery(this.searchQueryPatch('type'))
            await this.readTypes()
        },
        setCategoryOptions (categories) {
            this.category_list = categories.map(({ category_name }) => ({
                text: category_name.toLocaleUpperCase(),
                value: category_name
            }))
            this.category_list_en = categories.reduce((_categoryListEN, _category) => {
                const { category_name, category_description } = _category
                _categoryListEN[category_name] = category_description
                return _categoryListEN
            }, {})
        },
        // Category 생성·수정·삭제 뒤 Dictionary·집계값 폼의 카테고리 선택지를 새 목록으로 (표는 건드리지 않는다)
        async refreshCategoryOptions () {
            try {
                this.setCategoryOptions((await this.$axios.get('/parser/categories')).data)
            } catch (error) {
                console.log(` ~ error => `, error);
            }
        },
        async readCategory (mode = 'initial') {
            let readCategoryURL = '/parser/categories'
            if (mode === 'search') {
                const { category_id, category_name } = this.categorySearchForm
                if (!category_id && !category_name) {
                    this.$EventBus.$emit('toast-warning', 'Category 조회', '검색 조건을 하나 이상 입력해 주세요.')
                    return false
                }
                readCategoryURL = { url: `/parser/categories`, params : {} }
                if (category_id) readCategoryURL.params.id = category_id
                if (category_name) readCategoryURL.params.category_name = category_name
            }

            try {
                this.is_category_loaded = false
                const searchPatch = mode === 'search' ? this.searchQueryPatch('category') : null
                const res_categories = await this.$axios(readCategoryURL)

                if (mode === 'initial') {
                    this.setCategoryOptions(res_categories.data)
                }
                if (searchPatch) this.replaceQuery(searchPatch)

                this.categorylist = res_categories.data
            } catch (error) {
                this.setLoadError('category', error)
                this.common_error_handling(error)
            }
        },
        async createUpdateCategory () {
            if (this.saving) return
            const { id, category_name, category_description } = this.categoryForm
            if (!category_name) {
                this.$EventBus.$emit('toast-warning', 'Category 저장', '카테고리 이름을 입력해 주세요.')
                return
            }
            const _newCategory = { category_name }
            // id 가 있으면 수정, 없으면 신규
            if (id != null) _newCategory.id = id

            if (category_description) {
                _newCategory.category_description = category_description
            }

            this.saving = true
            try {
                let res_category = await this.$axios.post('parser/categories', _newCategory)
                this.throwIfFlattenedError(res_category.data)
                if (res_category.data.length) {
                    const _update_category = res_category.data[0]
                    this.categorylist = this.categorylist || []
                    const _update_target_category_idx = this.categorylist.findIndex(({ id }) => id === _update_category.id)
                    if (_update_target_category_idx < 0) {
                        this.categorylist.push({ index: this.categorylist.length, ..._update_category })
                    } else {
                        this.categorylist[_update_target_category_idx].category_name = category_name
                        this.categorylist[_update_target_category_idx].category_description = category_description
                    }
                }
                this.$EventBus.$emit('toast-success', 'Category 저장', `'${category_name}' 을(를) 저장했습니다.`)
                // 폼에 수정한 id 가 남으면 다음 저장이 같은 Category 를 덮어쓴다
                this.resetCategoryForm()
                this.refreshCategoryOptions()
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.handlingErrorCreateUpdateCategory(error)
            } finally {
                this.saving = false
            }
        },
        async handlingErrorCreateUpdateCategory (error) {
            if (error.response && error.response.status === 409) {
                this.$EventBus.$emit('toast-failure', 'Category 저장 실패', '이미 등록된 Category 이름입니다.')
                return
            }
            this.$EventBus.$emit('toast-failure', 'Category 저장 실패', `${this.errorReason(error)} Category 목록을 다시 불러옵니다.`)
            await this.readCategory()
        },
        async editCategory (categoryid) {
            await this.resetCategoryForm()
            const _edit_target_category = this.categorylist.find(({ id }) => id === categoryid)
            if (!_edit_target_category) {
                this.$EventBus.$emit('toast-failure', '알림', '잘못된 카테고리 id 입니다. 목록을 다시 불러옵니다.')
                await this.readCategory()
            } else {
                const { index, id, category_name, category_description } = _edit_target_category
                this.categoryForm = { index, id, category_name, category_description }

                if (!this.collapseTabs.category) {
                    this.collapseTabs.category = true
                }
                // 조회 탭에서 눌러도 수정 폼이 보이게 '생성 및 수정' 탭으로
                this.tabIndexCategory = 0
            }
        },
        async resetCategoryForm () {
            try {
                this.categoryForm = { index: null, id: null, category_name: null, category_description: null }
            } catch (error) {
                if (error?.response?.status === 401) return
                this.common_error_handling(error)
            }
        },
        async resetCategorySearchForm () {
            this.categorySearchForm = { category_id: null, category_name: null }
            this.replaceQuery(this.searchQueryPatch('category'))
            await this.readCategory()
        },
        async deleteCategory (categoryid) {
            if (this.deleting_key) return
            const _edit_target_category = this.categorylist.find(({ id }) => id === categoryid)
            const _is_confirmed_Category = await this.confirmDelete('Category 삭제', _edit_target_category?.category_name ?? '-', categoryid)
            if (!_is_confirmed_Category) return
            this.deleting_key = `category-${categoryid}`
            try {
                if (!_edit_target_category) {
                    this.$EventBus.$emit('toast-failure', '알림', '잘못된 카테고리 id 입니다. Category 리스트를 다시 불러오겠습니다.')
                } else {
                    const res_delete = await this.$axios.delete('parser/categories', { data: { id: categoryid }})
                    this.throwIfFlattenedError(res_delete.data)
                    const _delete_target_category = this.categorylist.findIndex(({ id }) => id === categoryid)
                    if (_delete_target_category < 0) {
                        this.$EventBus.$emit('toast-failure', '알림', '잘못된 카테고리 id 입니다. Category 리스트를 다시 불러오겠습니다.')
                        await this.readCategory()
                    } else {
                        this.categorylist.splice(_delete_target_category, 1)
                        this.$EventBus.$emit('toast-success', 'Category 삭제', `'${_edit_target_category.category_name}' 을(를) 삭제했습니다.`)
                    }
                    this.refreshCategoryOptions()
                }
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.common_error_handling(error, this.handlingErrorDeleteCategory)
            } finally {
                this.deleting_key = null
            }
        },
        async handlingErrorDeleteCategory (error) {
            if (error.response) {
                const { status } = error.response
                if (status === 404) {
                    this.$EventBus.$emit('toast-failure', '알림', '이미 삭제되었거나 존재하지 않는 Criteria Category 입니다. Category 데이터를 새로 불러오겠습니다.')
                } else {
                    this.$EventBus.$emit('toast-failure', '알림', '죄송합니다. 에러가 발생해 Category 데이터를 새로 불러오겠습니다.')
                }
                await this.readCategory()
            } else {
                this.$EventBus.$emit('toast-failure', '알림', '죄송합니다. 알 수 없는 에러가 발생해 Category 데이터를 새로 불러오겠습니다.')
                await this.readCategory()
            }
        },
        // 전체 화면 로더(is_definition_loaded=false)는 created 의 첫 조회에만 쓴다 — 재조회가 다른 행의 편집을 지우지 않게
        async readDefinitions (mode = 'intitial') {
            let readDefinitionQuery = {
                url: '/parser/definitions',
                params: {}
            }

            if (mode === 'search') {
                const { id, criteriaName, subsCode, theme, type } = this.definitionSearchForm
                if (!id && !criteriaName && !subsCode && !theme && !type) {
                    this.$EventBus.$emit('toast-warning', 'Definition 조회', '검색 조건을 하나 이상 입력해 주세요.')
                    return false
                }
                if (id) readDefinitionQuery.params.id = id
                if (criteriaName) readDefinitionQuery.params.criteria_name = criteriaName
                if (subsCode) readDefinitionQuery.params.sub_code = subsCode
                if (theme) readDefinitionQuery.params.theme = theme
                if (type) readDefinitionQuery.params.type = type
            }

            try {
                this.load_errors.definition = ''
                const res_definitions = await this.$axios(readDefinitionQuery)
                const definitions_list = res_definitions.data
                this.definitionlist = definitions_list.reduce((_definitions, _def) => {
                    _definitions.push({ ..._def,
                        is_edit_mode: false,
                        _showDetails: false,
                        changingInfo: { criteria: _def.criteria_id, type: _def.type, year: _def.year, collection_year: _def.collection_year }
                    })
                    return _definitions
                }, [])
            } catch (error) {
                if (error?.response?.status === 401) return
                if (error.response && error.response.status === 404) {
                    // 백엔드에 sub_code 없는 목록 조회(GET /parser/definitions)가 없다 - 알림 없이 안내만 한다
                    this.load_errors.definition = 'Definition 전체 목록 조회 API 가 제공되지 않습니다 (백엔드 필요)'
                } else {
                    this.setLoadError('definition', error)
                    await this.common_error_handling(error, this.handlingErrorReadDefinitionANDDictionary)
                }
            } finally {
                if (mode === 'intitial') {
                    this.is_definition_loaded = true
                }
            }
        },
        async handlingErrorReadDefinitionANDDictionary (error) {
			if (error) {
				if (error.response) {
					const { status } = error.response
					if ([400, 403, 404].includes(status)) {
						alert(getErrorMessage(error, '요청을 처리하지 못했습니다.'))
					}
				} else {
					alert('네트워크 오류가 발생했습니다. 연결을 확인한 뒤 다시 시도해 주세요.')
				}
			}
		},
        async onUpdateDefinition (defid) {
            try {
                const _definition_idx = this.definitionlist.findIndex(({ id }) =>  id === defid)
                if (_definition_idx < 0) {
                    alert('존재하지 않는 definition 입니다. definition을 다시 불러오겠습니다.')
                    await this.readDefinitions()
                } else {
                    const _updating_definition = { ...this.definitionlist[_definition_idx] }
                    _updating_definition.criteria_id = _updating_definition.changingInfo.criteria
                    _updating_definition.type = _updating_definition.changingInfo.type
                    _updating_definition.year = _updating_definition.changingInfo.year
                    _updating_definition.collection_year = _updating_definition.changingInfo.collection_year

                    const _res_update_defition = await this.$axios.post(`/parser/definitions/${_updating_definition.sub_code}`,
                        { ..._updating_definition, definition_id: _updating_definition.id}
                    )
                    this.throwIfFlattenedError(_res_update_defition.data)

                    const updated_defition = _res_update_defition.data
                    let _criteria = this.dictionarylist.find(_dict => _dict.id === updated_defition.criteria_id)
                    if (_criteria) {
                        _updating_definition.is_edit_mode = true
                        _updating_definition._showDetails = true

                        _updating_definition.year = updated_defition.year
                        _updating_definition.collection_year = updated_defition.collection_year
                        _updating_definition.changingInfo = {
                            criteria: updated_defition.criteria_id,
                            type: updated_defition.type,
                            year: updated_defition.year,
                            collection_year: updated_defition.collection_year
                        }
                        
                        _updating_definition.criteria_name = _criteria.criteria_name
                    }

                    this.$set(this.definitionlist, _definition_idx, _updating_definition)
                }                
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.common_error_handling(error, this.handlingErrorCreateCriteriaDefinition)
            }
        },
        async handlingErrorCreateCriteriaDefinition (error) {
			if (error) {
				if (error.response) {
					const { status } = error.response
					if ([400, 404].includes(status)) {
						alert(getErrorMessage(error, '요청을 처리하지 못했습니다.'))
						await this.readDefinitions()
					} else {
                        alert(getErrorMessage(error, '요청을 처리하지 못했습니다.'))
                    }
				} else {
					alert('알 수 없는 error가 발생했습니다. Subs 수정창을 닫고 다시 시도해주세요.')
				}
			}
		},
        async deleteDefinition (defIndex, subCode, defid) {
            if (this.deleting_key) return
            const _target_definition = this.definitionlist.find(d => d.id === defid)
            const _confirmed_delete_definition = await this.confirmDelete('Criteria Definition 삭제', `${_target_definition?.criteria_name ?? '-'} / ${subCode}`, defid)
            if (!_confirmed_delete_definition) return
            this.deleting_key = `definition-${defid}`
            try {
                const res_delete = await this.$axios.delete(`/parser/definitions/${subCode}`, {
                    data: { definition_id: defid }
                })
                this.throwIfFlattenedError(res_delete.data)

                const _delete_idx = this.definitionlist.findIndex(d => d.id === defid)
                if (_delete_idx > -1) {
                    this.definitionlist.splice(_delete_idx, 1)
                } else {
                    this.$EventBus.$emit('toast-failure', '알림', '잘못된 처리가 있어 definition 목록을 다시 불러옵니다.')
                    await this.readDefinitions()
                    return
                }
                this.$EventBus.$emit('toast-success', 'Criteria Definition 삭제', `${subCode} 을(를) 삭제했습니다.`)
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.common_error_handling(error, this.handlingErrorDeleteCriteriaDefinition)
            } finally {
                this.deleting_key = null
            }
        },
        async handlingErrorDeleteCriteriaDefinition (error) {
			if (error) {
				if (error.response) {
					const { status } = error.response
					if ([400, 404].includes(status)) {
						this.$EventBus.$emit('toast-failure', '알림', getErrorMessage(error, '요청을 처리하지 못했습니다.'))
						await this.readDefinitions()
					} else {
                        this.$EventBus.$emit('toast-failure', '알림', getErrorMessage(error, '요청을 처리하지 못했습니다.'))
                    }
				} else {
					this.$EventBus.$emit('toast-failure', '알림', '알 수 없는 error가 발생했습니다. Subs 수정창을 닫고 다시 시도해주세요.')
				}
			}
		},
        async resetDefinitionsSearchForm () {
            this.definitionSearchForm = { id: null, criteriaName: null, subsCode: null, theme: null, type: null }
            await this.readDefinitions('reset')
        },
        async onResetDefinition (defid) {
            const _definition_idx = this.definitionlist.findIndex(({ id }) =>  id === defid)
            if (_definition_idx < 0) {
                alert('존재하지 않는 definition 입니다. definition을 다시 불러오겠습니다.')
                await this.readDefinitions()
            } else {
                const _reset_definition = { ...this.definitionlist[_definition_idx] }
                const { criteria_id, type, year, collection_year } = _reset_definition
                _reset_definition.changingInfo = { criteria: criteria_id, type, year, collection_year }
                this.$set(this.definitionlist, _definition_idx, _reset_definition)
                this.definitionlist[_definition_idx].is_edit_mode = false
                this.$nextTick(() => {
                    this.definitionlist[_definition_idx].is_edit_mode = true
                })
            }
        },
        async createDictionary () {
            if (this.saving) return
            const { name, theme, category, inDashboard } = this.dictionaryForm
            if (!name || !theme || !category) {
                this.$EventBus.$emit('toast-warning', 'Dictionary 저장', 'Criteria 이름·유형·카테고리를 입력해 주세요.')
                return
            }
            this.saving = true
            try {
                let reqData = {
                    criteria_name: name,
                    category,
                    theme,
                    in_dashboard: inDashboard
                }

                const _created_criteria_form = await this.$axios.post('/parser/dictionaries', reqData)
                this.throwIfFlattenedError(_created_criteria_form.data)
                this.dictionarylist = this.dictionarylist || []
                this.dictionarylist.push(this.normalizeDictionary(_created_criteria_form.data))
                this.$EventBus.$emit('toast-success', 'Dictionary 저장', `'${name}' 을(를) 저장했습니다.`)
                this.resetDictionaryForm()
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.handlingErrorOnDictionaryCreateUpdate(error)
            } finally {
                this.saving = false
            }
        },
        // 생성 폼만 비운다 (목록을 다시 읽으면 다른 행에서 고치던 내용이 사라진다)
        resetDictionaryForm () {
            this.dictionaryForm = { name: null, theme: null, category: null, inDashboard: null }
        },
        async showEditDefinition (defId, cb_toggleDetails) {
            const _definition_idx = this.definitionlist.findIndex(({ id }) =>  id === defId)
            
            if (_definition_idx < 0) {
                alert('존재하지 않는 definition 입니다. definition을 다시 불러오겠습니다.')
                await this.readDefinitions()
            } else {
                this.definitionlist[_definition_idx].is_edit_mode = !this.definitionlist[_definition_idx].is_edit_mode
                cb_toggleDetails()
            }
        },
        async showDefinitionDetails (defId, detailsShowStatus, cb_toggleDetails, mode = 'detail') {
            const _definition_idx = this.definitionlist.findIndex(({ id }) =>  id === defId)
            
            if (_definition_idx < 0) {
                alert('존재하지 않는 definition 입니다. definition을 다시 불러오겠습니다.')
                await this.readDefinitions()
            } else {
                const _latest_edit_mode = this.definitionlist[_definition_idx].is_edit_mode ? 'edit' : 'detail'
                if (mode === 'edit') {
                    this.definitionlist[_definition_idx].is_edit_mode = true
                } else if (this.definitionlist[_definition_idx].is_edit_mode) {
                    this.definitionlist[_definition_idx].is_edit_mode = false
                }

                if (_latest_edit_mode === mode) {
                    cb_toggleDetails()
                } else {
                    if (!detailsShowStatus) {
                        cb_toggleDetails()
                    } else {
                        detailsShowStatus = true
                    }
                }
            }
        },
        // 조회·생성 응답에 화면용 상태(수정 모드·상세 펼침·편집값)를 붙인다
        normalizeDictionary (_dict) {
            const { criteria_name, theme, category, description, in_dashboard } = _dict
            return { ..._dict, is_edit_mode: false, _showDetails: false, changingInfo: { criteria_name, theme, category, description, in_dashboard } }
        },
        // 전체 화면 로더(is_dictionary_loaded=false)는 created 의 첫 조회에만 쓴다 — 재조회가 다른 행의 편집을 지우지 않게
        async readDictionary (mode = 'initial') {
            let readDefinitionQuery = {
                url: '/parser/dictionaries',
                params: {}
            }
            // 대시보드 조건: 백엔드가 in_dashboard 를 문자열로 비교해 거르지 못하므로 보내지 않고 받은 목록에서 거른다
            let dashboardFilter = null

            if (mode === 'search') {
                const { id, name, theme, category, inDashboard } = this.dictionarySearchForm
                if (!id && !name && !theme && !category && inDashboard === null) {
                    this.$EventBus.$emit('toast-warning', 'Dictionary 조회', '검색 조건을 하나 이상 입력해 주세요.')
                    return false
                }
                if (id) readDefinitionQuery.params.criteria_id = id
                if (name) readDefinitionQuery.params.criteria_name = name
                if (theme) readDefinitionQuery.params.theme = theme
                if (category) readDefinitionQuery.params.category = category
                dashboardFilter = inDashboard
            }

            try {
                this.load_errors.dictionary = ''
                const searchPatch = mode === 'search' ? this.searchQueryPatch('dictionary') : null
                const res_dictionaries = await this.$axios(readDefinitionQuery)
                let dictionaries_list = res_dictionaries.data.map(this.normalizeDictionary)
                if (dashboardFilter !== null) {
                    // 값 없음(null)은 미적용으로 본다
                    dictionaries_list = dictionaries_list.filter(_dict => !!_dict.in_dashboard === dashboardFilter)
                }
                this.dictionarylist = dictionaries_list

                if (searchPatch) this.replaceQuery(searchPatch)
                // ?dictionary_id 로 가리킨 행은 다시 읽어도 펼쳐 둔다. 목록에 없으면 키를 뺀다.
                const detailId = this.$route.query.dictionary_id
                if (detailId !== undefined) {
                    const _detail = typeof detailId === 'string' && this.dictionarylist.find(({ id }) => String(id) === detailId)
                    if (_detail) _detail._showDetails = true
                    else this.replaceQuery({ dictionary_id: null })
                }
            } catch (error) {
                if (error?.response?.status === 401) return
                this.setLoadError('dictionary', error)
                await this.common_error_handling(error, this.handlingErrorReadDefinitionANDDictionary)
            } finally {
                if (mode === 'initial') {
                    this.is_dictionary_loaded = true
                }
            }
        },
        async onUpdateDictionary (dicId) {
            try {
                const _dict_index = this.dictionarylist.findIndex((_dict => _dict.id === dicId))
                if (_dict_index < 0) {
                    alert('존재하지 않는 Criteria 입니다. 다시 불러오겠습니다.')
                    await this.readDictionary()
                } else {
                    let _updating_dictionary = { ...this.dictionarylist[_dict_index] }
                    const { criteria_name, theme, category, description, in_dashboard } = _updating_dictionary.changingInfo

                    let _updated_criteria = await this.$axios.post('/parser/dictionaries', {
                        criteria_id: dicId,
                        criteria_name, theme, category, description, in_dashboard
                    })
                    this.throwIfFlattenedError(_updated_criteria.data)

                    if (_updated_criteria.data.id === dicId) {
                        _updated_criteria = _updated_criteria.data

                        const { criteria_name, theme, category, description, in_dashboard } = _updated_criteria
                        _updating_dictionary = {
                            ..._updating_dictionary,
                            criteria_name, theme, category, description, in_dashboard,
                            changingInfo: {
                                criteria_name, theme, category, description, in_dashboard
                            }
                        }

                        this.$set(this.dictionarylist, _dict_index, _updating_dictionary)
                        this.$EventBus.$emit('toast-success', 'Dictionary 저장', `'${criteria_name}' 을(를) 저장했습니다.`)
                    }
                }
            } catch (error) {
                if (error?.response?.status === 401) return
                await this.handlingErrorOnDictionaryCreateUpdate(error)
            }
        },
        async handlingErrorOnDictionaryCreateUpdate (error) {
            // 400(필수값)/403(중복)/404(없는 항목)는 서버 사유를 그대로 보여 준다
            if (error.response && [400, 403, 404].includes(error.response.status)) {
                this.$EventBus.$emit('toast-failure', 'Dictionary 저장 실패', getErrorMessage(error, '저장하지 못했습니다.'))
                return
            }
            this.$EventBus.$emit('toast-failure', 'Dictionary 저장 실패', `${this.errorReason(error)} Criteria Dictionary 를 다시 불러옵니다.`)
            await this.readDictionary()
        },
        async onDeleteDictionary (dicId) {
            if (this.deleting_key) return
            const _target_dictionary = this.dictionarylist.find(({ id }) => id === dicId)
            const is_confirmed_delete_dictionary = await this.confirmDelete('Criteria Dictionary 삭제', _target_dictionary?.criteria_name ?? '-', dicId)
            if (!is_confirmed_delete_dictionary) return
            this.deleting_key = `dictionary-${dicId}`
            try {

                const _dictionary_idx = this.dictionarylist.findIndex(({ id }) =>  id === dicId)
                if (_dictionary_idx < 0) {
                    this.$EventBus.$emit('toast-failure', '알림', '존재하지 않는 criteria 입니다. criteria를 다시 불러오겠습니다.')
                    await this.readDictionary()
                } else {
                    const res_delete = await this.$axios.delete(`/parser/dictionaries`, {
                        data: { criteria_id: dicId }
                    })
                    // 참조하는 Definition 이 있으면 [{msg, def_pd}, 403] 으로 온다 — handlingErrorOnDelete 가 sub_code 를 붙인다
                    this.throwIfFlattenedError(res_delete.data)
                    if (this.$route.query.dictionary_id === String(dicId)) this.replaceQuery({ dictionary_id: null })
                    if (this.dictionarylist.length) {
                        this.dictionarylist.splice(_dictionary_idx, 1)
                    } else {
                        this.$EventBus.$emit('toast-failure', '알림', '잘못된 처리가 있어 definition 목록을 다시 불러옵니다.')
                        await this.readDefinitions()
                    }
                    this.$EventBus.$emit('toast-success', 'Criteria Dictionary 삭제', `'${_target_dictionary.criteria_name}' 을(를) 삭제했습니다.`)
                }
            } catch (error) {
                if (error?.response?.status === 401) return
                this.common_error_handling(error, this.handlingErrorOnDelete)
            } finally {
                this.deleting_key = null
            }
        },
        handlingErrorOnDelete (error) {
            if (error?.response?.status === 401) return
            let error_message = error && error.response
                ? getErrorMessage(error, '삭제하지 못했습니다.')
                : '네트워크 오류로 삭제하지 못했습니다.'

            const def_pd = error && error.response && error.response.data && error.response.data.def_pd
            if (Array.isArray(def_pd) && def_pd.length) {
                error_message += ` 참조하고 있는 sub_code는 ${def_pd.map(def => def.sub_code).join(', ')} 입니다.`
            }

            this.$EventBus.$emit('toast-failure', '알림', error_message)
        },
        async showDictionaryDetails (dicId, detailsShowStatus, cb_toggleDetails, mode = 'detail') {
            const _dictionary_idx = this.dictionarylist.findIndex(({ id }) =>  id === dicId)
            
            if (_dictionary_idx < 0) {
                alert('존재하지 않는 Criteria 입니다. Criteria Dictionary를 다시 불러오겠습니다.')
                await this.readDictionary()
            } else {
                const _latest_edit_mode = this.dictionarylist[_dictionary_idx].is_edit_mode ? 'edit' : 'detail'
                if (mode === 'edit') {
                    this.dictionarylist[_dictionary_idx].is_edit_mode = true
                } else if (this.dictionarylist[_dictionary_idx].is_edit_mode) {
                    this.dictionarylist[_dictionary_idx].is_edit_mode = false
                }

                if (_latest_edit_mode === mode) {
                    cb_toggleDetails()
                } else {
                    if (!detailsShowStatus) {
                        cb_toggleDetails()
                    } else {
                        detailsShowStatus = true
                    }
                }

                // 펼친 행을 ?dictionary_id 로 남긴다(링크로 가리키기용 — 수정 모드·편집값은 올리지 않는다)
                if (this.dictionarylist[_dictionary_idx]._showDetails) {
                    this.replaceQuery({ dictionary_id: dicId })
                } else if (this.$route.query.dictionary_id === String(dicId)) {
                    this.replaceQuery({ dictionary_id: null })
                }
            }
        },
        async resetDictionarySearchForm () {
            this.dictionarySearchForm = { id: null, name: null, theme: null, category: null, inDashboard: null }
            this.replaceQuery(this.searchQueryPatch('dictionary'))
            await this.readDictionary('reset')
        },
        async onResetDictionary (defid) {
            const _dictionary_idx = this.dictionarylist.findIndex(({ id }) =>  id === defid)
            if (_dictionary_idx < 0) {
                alert('존재하지 않는 definition 입니다. definition을 다시 불러오겠습니다.')
                await this.readDictionary()
            } else {
                const _reset_dictionary = { ...this.dictionarylist[_dictionary_idx] }
                const { criteria_name, theme, category, description, in_dashboard } = _reset_dictionary
                _reset_dictionary.changingInfo = { criteria_name, theme, category, description, in_dashboard }
                this.$set(this.dictionarylist, _dictionary_idx, _reset_dictionary)
                this.dictionarylist[_dictionary_idx].is_edit_mode = false
                this.$nextTick(() => {
                    this.dictionarylist[_dictionary_idx].is_edit_mode = true
                })
            }
        },
        // 행 객체를 받는다: 표 index 는 Type 을 지우면 typelist 위치와 어긋난다
        async parseCriteriaDefinition (typeItem) {
            const criteria_type = typeItem.type_name
            const _is_confirmed_parse = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '파서 값 다시 만들기',
                message: `'${criteria_type}' 타입의 전체 업체 답변을 다시 파싱합니다. 기존 파서 값이 새 값으로 바뀔 수 있고 시간이 걸릴 수 있습니다. 진행할까요?`
            })
            if (!_is_confirmed_parse) return
            this.is_running_parser_feature = true
            typeItem.is_parsing = true
            try {
                const res_parse = await this.$axios({
                    url: '/parser/values',
                    method: 'post',
                    params: { type: criteria_type.toLocaleLowerCase() }
                })
                this.throwIfFlattenedError(res_parse.data)

                this.$EventBus.$emit('toast-success', '파싱 완료', `${criteria_type} type의 데이터 파싱을 완료하였습니다.`)
            } catch (error) {
                if (error?.response?.status === 401) return
                this.$EventBus.$emit('toast-failure', '파싱 실패', `${criteria_type} 타입 파싱에 실패했습니다. (${this.errorReason(error)})`)
            } finally {
                typeItem.is_parsing = false
                this.is_running_parser_feature = false
            }
        },
        async downloadAggregateCriteriaValueExcel (typeItem) {
            const criteria_type = typeItem.type_name
            this.is_running_parser_feature = true
            typeItem.is_aggregation_downloading = true
            try {
                const response = await this.$axios.get(`/parser/values/excel`, {
                    params: { type: criteria_type },
                    responseType: 'blob'
                })

                const problem = await this.excelResponseProblem(response, '받을 데이터가 없습니다.')
                if (problem) {
                    this.$EventBus.$emit('toast-warning', '집계값 다운로드', `${criteria_type}: ${problem}`)
                    return
                }
                this.downloadFileFromResponse(response, `${criteria_type}_타입_집계값_엑셀.xlsx`)
                this.$EventBus.$emit('toast-success', '집계값 다운로드', `${criteria_type} 타입 집계값을 내려받았습니다.`)
            } catch (error) {
                if (error?.response?.status === 401) return
                this.$EventBus.$emit('toast-failure', '집계값 다운로드 실패', `${criteria_type}: ${await this.blobErrorMessage(error)}`)
            } finally {
                typeItem.is_aggregation_downloading = false
                this.is_running_parser_feature = false
            }
        },
        resetAggregationFieldForm () {
            this.aggregationDownloadSearchForm = {
                type: null, category: null, definitionId: null
            }
            this.aggregation_notice = ''
        },
        async downloadAggregationResult () {
            if (this.is_downloading_aggregationData) return
            const form = this.aggregationDownloadSearchForm
            if (!form.type && !form.category && !form.definitionId) {
                this.$EventBus.$emit('toast-warning', '집계값 다운로드', '조건을 하나 이상 선택해 주세요.')
                return
            }

            this.aggregation_notice = ''
            if (form.definitionId) {
                const _selected_definition = (this.definitionlist || []).find(({ id }) => id === form.definitionId)
                if (_selected_definition && (form.type !== _selected_definition.type || form.category !== _selected_definition.category)) {
                    form.type = _selected_definition.type
                    form.category = _selected_definition.category
                    this.aggregation_notice = '선택한 Definition 에 맞춰 타입/카테고리를 바꿨습니다.'
                }
            }

            if (form.category && !form.type) {
                this.$EventBus.$emit('toast-warning', '집계값 다운로드', '카테고리로 조회하려면 타입을 선택해 주세요.')
                return
            }

            this.is_downloading_aggregationData = true
            try {
                const response_search_aggregation = await this.$axios.get('/parser/values/excel', {
                    params: {
                        type: this.measure_types_pair[form.type],
                        category: form.category,
                        definition_id: form.definitionId
                    },
                    responseType: 'blob'
                })

                const problem = await this.excelResponseProblem(response_search_aggregation, '조회된 집계값이 없습니다.')
                if (problem) {
                    this.$EventBus.$emit('toast-warning', '집계값 다운로드', problem)
                    return
                }

                let filename = Object.values(form).join('_')
                if (form.definitionId) {
                    const _selected_definition = (this.definitionlist || []).find(({ id }) => id === form.definitionId)
                    if (_selected_definition) filename = `${filename}_${_selected_definition.criteria_name}`
                }
                this.downloadFileFromResponse(response_search_aggregation, `${filename}_집계값_엑셀`)
            } catch (error) {
                if (error?.response?.status === 401) return
                this.$EventBus.$emit('toast-failure', '집계값 다운로드 실패', await this.blobErrorMessage(error))
            } finally {
                this.is_downloading_aggregationData = false
            }
        }
    }
}
</script>

<style lang="scss">
.criteria-main {
    .b-table-sticky-header {
        height: 70vh;
        max-height: 480px;
        margin-bottom: 0px !important;
    }
}

.criteria-helper {
    .b-table-sticky-header {
        height: 100%;
        max-height: 280px;
        margin-bottom: 0px !important;
    }
}
</style>